if (!customElements.get('related-products')) {
  customElements.define(
    'related-products',
    class RelatedProducts extends HTMLElement {
      connectedCallback() {
        this.initSlider();
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      destroySlider() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      initSlider() {
        this.sliderEl = this.querySelector('[data-related-slider]');
        if (!this.sliderEl || typeof Swiper === 'undefined') return;

        const prevEl = this.querySelector('[data-related-prev]');
        const nextEl = this.querySelector('[data-related-next]');
        const slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
        const desktopDisabled = slideCount <= 4;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const swiperOptions = {
          slidesPerView: 2,
          spaceBetween: 12,
          watchOverflow: true,
          a11y: true,
          navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 16,
              enabled: !desktopDisabled,
            },
          },
        };
        if (prefersReducedMotion) swiperOptions.speed = 0;

        this.swiper = new Swiper(this.sliderEl, swiperOptions);
      }
    }
  );
}
